import React, { Component } from 'react';
import './Section.css';
// import Panel from '../Panel/Panel';
import SectionHeader from '../SectionHeader/SectionHeader';

import Accordion from '../Accordion/Accordion';

class Section extends Component {

    constructor(props) {
        super(props);
        this.state = {
            mountedHeight: "100vH"
        };
        this.currentWidth = 0;
    }

    componentDidMount() {
        window.addEventListener("resize", this.resizeBackground);
        this.resizeBackground();
    }

    resizeBackground = () => {

        if (this.currentWidth === 0 || this.currentWidth !== window.innerWidth) {
            this.currentWidth = window.innerWidth;
            ////console.log(("resizeBackground - resizeBackground: " + window.innerHeight);

            if (window.innerHeight < 500) {
                this.setState({mountedHeight: Math.round(window.innerHeight*1.5) + "px"});
            } else {
                this.setState({mountedHeight: window.innerHeight + "px"});
            }

        }

    }

  render() {

      if (this.props.value === undefined || this.props.value.panels === undefined) {
          return null;
      }

      var imgUrl = "";
      if (this.props.value.images && this.props.value.images.length > 0) {
          imgUrl = this.props.value.images[0].url;
      }


    return (
        <section className="Section" style={{backgroundImage: 'url(' + imgUrl + ')', 'height': this.state.mountedHeight, 'maxHeight': this.state.mountedHeight, 'minHeight': this.state.mountedHeight}}>
          <SectionHeader title={this.props.value.title}></SectionHeader>
          <div className="Content">
              <div className="PanelTable">
                  <div className="row">
                      <div className="row col-lg-6 col-md-8 col-sm-12">
                          <Accordion panels={this.props.value.panels} onExpand={this.props.onExpand} onCollapse={this.props.onCollapse}></Accordion>
                      </div>
                  </div>
              </div>
          </div>
        </section>
    );
  }
}

export default Section;





// WEBPACK FOOTER //
// ./src/components/Section/Section.js